import { createSelector } from "reselect";

import { PartiallyMatchedEmployee } from "../model";
import { PartiallyMatchedEmployeeState } from "../common/model";

import { Location } from "redux-little-router";

export type SelectorState = PartiallyMatchedEmployeeState & { router: Location };

export const routeIdSelector = (state: SelectorState) => {
    return state.router.params && state.router.params.referralId;
};

export const partiallyMatchedEmployeesSelector = (state: SelectorState): PartiallyMatchedEmployee[] => {
    return state.partiallyMatchedEmployees;
};

export const partiallyMatchedEmployeeSelector = createSelector(
    partiallyMatchedEmployeesSelector,
    routeIdSelector,
    (partiallyMatchedEmployees: PartiallyMatchedEmployee[], id: any) => {
        return partiallyMatchedEmployees.filter(c => c.id === id)[0] || {} as PartiallyMatchedEmployee;
    }
);
